<template>
  <v-card color="basil">
    <v-tabs v-model="tab" background-color="transparent" grow>
      <v-tab v-for="(item, i) in items" :key="item">
        <v-icon left>{{icons[i]}}</v-icon>
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <action-plan-list :actionPlansList="actionPlansToMe" :byMe="false"></action-plan-list>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <action-plan-list :actionPlansList="actionPlansByMe" :byMe="true"></action-plan-list>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    ActionPlanList: () => import("@/_action-plan/components/List.vue")
  },
  data() {
    return {
      tab: null,
      items: ["Recebidos", "Enviados"],
      icons: ["mdi-arrow-down-bold", "mdi-arrow-up-bold"]
    };
  },
  computed: {
    ...mapGetters({
      actionPlansByMe: "ActionPlan/sentByMe",
      actionPlansToMe: "ActionPlan/sentToMe"
    })
  }
};
</script>
